<!-- 页面内容 -->
<template>
	<div>
		<div class="head_box">
			<Container
				class="f ac"
				style="height: 100%;"
			>
				<img
					src="@/assets/images/logo_black.png"
					alt=""
					class="logo"
					@click="$router.push('/home/gailan')"
				>
				<div class="w144"></div>
				<RouterLink
					class="link"
					to="/home/gailan"
				>{{$t("概览")}}</RouterLink>
				<RouterLink
					class="link"
					to="/home/project"
				>{{$t("项目")}}</RouterLink>
				<RouterLink
					class="link"
					to="/home/device/tuopu"
					:class="{cur: ['/home/device/jiaohuanji','/home/device/map'].includes($route.path)}"
				>{{$t("设备")}}</RouterLink>
				<RouterLink
					class="link"
					to="/home/weihu/warnRecard"
					:class="{ cur: ['/home/weihu/warnConfig'].includes($route.path) }"
				>{{$t("维护")}}</RouterLink>
				<div class="f1"></div>
				<div class="fs">
					<SelectLanguage />
				</div>

				<!-- <div class="f ac ">
					<img
						v-show="userStore.isOpenScreenFull"
						src="@/assets/images/81_close.png"
						alt=""
						class="icon2"
						@click="toScreenFull"
					>
					<img
						v-show="!userStore.isOpenScreenFull"
						src="@/assets/images/81.png"
						alt=""
						class="icon2"
						@click="toScreenFull"
					>
					<img
						@click="$router.push('/home/notice')"
						src="@/assets/images/82.png"
						alt=""
						class="icon2"
					>
				</div> -->

				<div class="shu"></div>
				<div
					class="person"
					@click.stop="showPersonMore = true;"
				>
					<img
						v-show="userInfo.avatar"
						:src="userInfo.avatar"
						alt=""
						class="avatar"
					>
					<img
						v-show="!userInfo.avatar"
						src="@/assets/images/12.png"
						alt=""
						class="avatar"
					>
					<div class="nick ell1">{{userInfo.nickname}}</div>
					<el-icon color="#555">
						<CaretBottom />
					</el-icon>

					<div class="downBox">
						<div
							class="dbContent"
							v-if="showPersonMore"
						>
							<div
								class="f ac pointer"
								@click.stop="$router.push('/home/my/base'), showPersonMore = false;"
							>
								<img
									src="@/assets/images/79.png"
									alt=""
								>
								<span>{{$t("个人设置")}}</span>
							</div>
							<div
								class="f ac pointer"
								@click.stop="logout(), showPersonMore = false"
							>
								<img
									src="@/assets/images/80.png"
									alt=""
								>
								<span>{{$t("退出登录")}}</span>
							</div>
						</div>
					</div>
				</div>
			</Container>
		</div>
		<!-- <div class="plac"></div> -->

		<DelConfrim ref="delConfrim" />
	</div>
</template>

<script setup lang="ts">
import SelectLanguage from '@/components/SelectLanguage.vue';
import { computed, ref } from 'vue';
import Container from './Container.vue';
import { DelConfrimType } from '@/types/global';
import DelConfrim from '@/components/DelConfrim.vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/store/user';
import { useI18n } from 'vue-i18n';
const router = useRouter();
const userStore = useUserStore();

const { t } = useI18n();

const showPersonMore = ref(false);

const delConfrim = ref<DelConfrimType>();

const userInfo = computed(() => userStore.userInfo);

function logout() {
	delConfrim.value?.show(t('确定退出系统吗？'), () => {
		userStore.loginOut();
		router.replace('/login');
	});
}

function toScreenFull() {
	const element = document.documentElement; // 整个<html>元素，即全页面
	// 或 const element = document.getElementById("myVideo"); // 指定元素

	if (userStore.isOpenScreenFull) {
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document.webkitExitFullscreen) {
			// Safari 和旧版 Chrome
			document.webkitExitFullscreen();
		} else if (document.msExitFullscreen) {
			// IE/Edge
			document.msExitFullscreen();
		} else if (document.mozCancelFullScreen) {
			// Firefox 旧版
			document.mozCancelFullScreen();
		}
	} else {
		// 发起全屏请求
		if (element.requestFullscreen) {
			element.requestFullscreen();
		} else if (element.webkitRequestFullscreen) {
			// Safari 和旧版 Chrome
			element.webkitRequestFullscreen();
		} else if (element.msRequestFullscreen) {
			// IE/Edge
			element.msRequestFullscreen();
		} else if (element.mozRequestFullScreen) {
			// Firefox 旧版
			element.mozRequestFullScreen();
		}
	}
}

window.addEventListener('click', () => {
	showPersonMore.value = false;
});
</script>

<style lang='scss' scoped>
@import '@/common/css/variables.scss';

.head_box,
.plac {
	height: $navHeight;
}

.head_box {
	width: 100%;
	background: #fff;
	box-shadow: 0px 1px 6px 1px rgba(0, 21, 41, 0.12);
	flex-shrink: 0;
}

.logo {
	width: 164px;
	height: 32px;
	flex-shrink: 0;
}

.w144 {
	width: 144px;
}

.link {
	font-size: 18px;
	color: #555555;
	cursor: pointer;
	margin-right: 32px;

	&.router-link-active,
	&.cur {
		color: $primary-color;
		position: relative;
		line-height: $navHeight;

		&::after {
			content: '';
			width: 24px;
			height: 4px;
			background: #3b6be9;
			border-radius: 2px 2px 2px 2px;
			position: absolute;
			bottom: 8px;
			left: 50%;
			transform: translateX(-50%);
		}
	}
}

:deep(.language_box) {
	width: 144px !important;

	.el-select__wrapper {
		height: 36px !important;
		background: #f6f7f9 !important;
		border-radius: 6px 6px 6px 6px;
		border-width: 0 !important;
		box-shadow: none !important;
	}
}

.shu {
	margin: 0 24px;
	border-right: 1px solid #eee;
	height: 24px;
}

.person {
	display: flex;
	align-items: center;
	cursor: pointer;
	position: relative;

	@keyframes showDown {
		0% {
			transform: scaleY(0);
			height: 0;
		}

		100% {
			transform: scaleY(1);
			height: auto;
		}
	}

	.downBox {
		position: absolute;
		top: 10px;
		right: 0;
		z-index: 8;
		padding-top: 48px;

		.dbContent {
			transform: scaleY(0);
			height: 0;
			animation: 0.25s showDown forwards;
			transform-origin: top;
			border-radius: 8px;
			box-shadow: 0 0 3px 1px #eee;
			background: #fff;
			padding: 32px;
			display: flex;
			flex-direction: column;
			gap: 32px 0;
			font-size: 16px;
			white-space: nowrap;

			img {
				width: 16px;
				height: 16px;
				margin-right: 12px;
			}
		}
	}

	.avatar {
		width: 32px;
		height: 32px;
		border-radius: 50%;
		margin-right: 16px;
	}

	.nick {
		max-width: 200px;
		margin-right: 12px;
		font-size: 16px;
		color: #555555;
	}
}

.icon2 {
	width: 36px;
	height: 36px;
	margin-left: 24px;
	cursor: pointer;
}
</style>